angular.module('erp.other.walmartlanding').run(['$templateCache', function($templateCache) {
  $templateCache.put("tpl/outbox.htm",
    "<div class=\"walmartlanding-header\" style=\"position: sticky; top: 0;\">\n" +
    "    <div class=\"center-mart walmartlanding-header-center-mart\">\n" +
    "        <a href=\"/\" class=\"walmartlanding-header-logo\" title=\"首页\" style=\"width: 94px;\">\n" +
    "            <img src=\"//asset.mangoerp.com/img/index1/logo1.png\" width=\"152\" alt=\"logo\" />\n" +
    "        </a>\n" +
    "        <a href=\"/ae\" rel=\"nofollow\" class=\"btn btn-sm active\">FREE TRIAL</a>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"mainoverall-style-walmartlanding\">\n" +
    "    <div class=\"banner-walmartlanding\">\n" +
    "        <div class=\"banner-center\">\n" +
    "            <div>Free cross-border ERP：Product Listing,Order Processing,Logistics Management,Data Analytics</div>\n" +
    "            \n" +
    "            <a href=\"/ae\" class=\"button\">FREE TRIAL</a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"wal-mart-card-container center-mart\">\n" +
    "        <h3>WHAT CAN WE DO?</h3>\n" +
    "        <div class=\"wal-mart-card-list\">\n" +
    "            <div class=\"wal-mart-card\" ng-repeat=\"item in vm.cardList\">\n" +
    "                <img ng-src=\"{{item.img}}\" alt=\"\" srcset=\"\">\n" +
    "                <div class=\"card-content\">\n" +
    "                    <h4>{{item.name}}</h4>\n" +
    "                    <div>{{item.center}}</div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"wal-mart-card-container center-mart\">\n" +
    "        <h3>WHY CHOOSE US?</h3>\n" +
    "        <div class=\"wal-mart-card-advantage-list\">\n" +
    "            <div class=\"wal-mart-card-advantage\">\n" +
    "                <img src=\"//img2.mangoerp.com/userbucket/adminadmin/2025-09-16/1758003270306-dehxn9bbf.png\" alt=\"\" srcset=\"\">\n" +
    "                <div class=\"card-content\">\n" +
    "                    <h4>Rich experience in platform integration</h4>\n" +
    "                    <div>Mango Store Manager has seamlessly integrated with over 20 mainstream e-commerce platforms, leveraging its technological advantages in integration with Wal Mart to ensure stable and efficient data transmission between platforms, providing sellers with a smooth operational experience.</div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"wal-mart-card-advantage\">\n" +
    "                <img src=\"//img2.mangoerp.com/userbucket/adminadmin/2025-09-16/1758003270889-5878zk3oh.png\" alt=\"\" srcset=\"\">\n" +
    "                <div class=\"card-content\">\n" +
    "                    <h4>Strong technical\n" +
    "                        team support</h4>\n" +
    "                    <div>Mango Store Manager has a professional technical team that continuously optimizes and upgrades. Based on the characteristics of the Wal Mart platform and seller needs, continuously improve functions and quickly solve technical problems to ensure the stable operation of seller stores.</div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"wal-mart-card-advantage\">\n" +
    "                <img src=\"//img2.mangoerp.com/userbucket/adminadmin/2025-09-16/1758003271442-87vvk1osb.png\" alt=\"\" srcset=\"\">\n" +
    "                <div class=\"card-content\">\n" +
    "                    <h4>One-stop service\n" +
    "                        concept</h4>\n" +
    "                    <div>Committed to providing one-stop online store operation and management services for sellers, deeply connecting e-commerce platforms, logistics warehousing, and merchants. In addition to easily managing the orders, products, inventory and other businesses of Wal Mart stores, you can also enjoy multi-dimensional services such as logistics docking, high-quality source recommendation, and intelligent operation assistance</div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"banner-bottom\">\n" +
    "        <div class=\"banner-bottom-center\">\n" +
    "            <div>Start And Grow On Walmart With Mango ERP</div>\n" +
    "            <div>Your most trustworthy free Walmart store management</div>\n" +
    "            <a href=\"/ae\" class=\"button\">FREE TRIAL</a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);
